import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import { getLink, trans } from "~/providers/lang";
import { ROUTES } from '~/const';
import ArrowRight from "../ArrowRight";

import "./style.less";

export default function HomeCovers() {
	const refVideo = useRef<HTMLVideoElement>(null);
	const refVideo2 = useRef<HTMLVideoElement>(null);

	function playVideo(video: HTMLVideoElement) {
		video.muted = true;
		video.defaultMuted = true;
	}

	useEffect(() => {
		if (refVideo.current && refVideo2.current) {
			playVideo(refVideo.current);
			playVideo(refVideo2.current);
		}
	}, []);

	return <>
		<div className="home-covers-images-container">
			<div className="home-covers-images">
				<video className="main-video" src="/img/video.mp4" poster="/img/video-cover.jpg" autoPlay={true} loop={true} muted={true} ref={refVideo} playsInline={true} />
			</div>
			<div className="home-covers-images-bg">
				<video className="cover-video" src="/img/video.mp4" poster="/img/video-cover.jpg" autoPlay={true} loop={true} muted={true} ref={refVideo2} playsInline={true} />
			</div>
			<div className="home-covers-background">
				<h2 className="new-collection-info" dangerouslySetInnerHTML={{ __html: trans("home.news.item35") }} />
				<div className="bg-back">
					<h2>
						{trans('home.bubble')}
					</h2>
					<Link to={getLink(ROUTES.wedding)} className="open-gallery">
						<ArrowRight />
					</Link>
				</div>
			</div>
		</div>
	</>;
}
